// extracted by mini-css-extract-plugin
export default {"title":"Manager_title__UVNEL","list":"Manager_list__7i+9w","item":"Manager_item__NEHjB"};